import React, { Component } from 'react';
import AnyModel from "../../models/anymodel";
import  PanelLayout  from "../layout/panel-layout";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import SimpleReactValidator from 'simple-react-validator';
import BFileInput from "../../helpers/bfile-input";
import { Markup } from 'interweave';
import { apiConstants } from "./../../constants/api.constants";
import moment from 'moment-jalaali';

class ShowMessage extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           model:new AnyModel(this.refs),
           recieverList:null,
           Files:[]
        };
      
       

    }

   
    
   
    componentWillReceiveProps(newProps)
    {
        const {model,recieverList}=newProps;
        if(model)
        {
            this.setState({
                model:model,
            });

            
            if(model.AttachedFiles!="")
            {
                let files= JSON.parse(model.AttachedFiles);
                this.setState({
     
                    Files:files
                })
            }
           

        }

       
    }


    render() { 
        //const {model} = this.props;
        const {recieverList,model,Files}= this.state;
        const {loading,error} = this.props;
    

 
        return ( 

        <PanelLayout title={"نمایش"}>

           
            <div className="panel-body custom">

            <div className="panel panel-default">
               
                <div className="toolbox">

                    <Link to="/message/inbox" className="btn btn-default btn-sm"> <i className="fa fa-arrow-right"></i> بازگشت </Link>
                
                </div>
            </div>
                
            <div class="panel panel-default">
                <div class="panel-heading">نمایش پیام</div>
                <div class="panel-body">

                    <form autoComplete="off" ref={c => { this.form = c }}>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <div className="row">
                                        <label className="col-md-1">
                                            فرستنده
                                        </label>
                                        <div className="col-md-11">
                                            {model && model.FromUser && model.FromUser.FullName}
                                        </div>
                                    </div>
                                  
                                  
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <label className="col-md-1">
                                            گیرنده
                                        </label>
                                        <div className="col-md-11">
                                            {model && model.ToUser && model.ToUser.FullName}
                                        </div>
                                    </div>
                                   
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <label className="col-md-1">
                                            تاریخ
                                        </label>
                                        <div className="col-md-11">
                                            {model && moment(model.SendDate).isValid() ? moment(model.SendDate).format('jYYYY/jMM/jDD HH:mm:ss'):''}
                                        </div>
                                    </div>
                                   
                                    
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <label className="col-md-1">
                                            عنوان پیام
                                        </label>
                                        <div className="col-md-11">
                                            {model && model.Title}
                                        </div>
                                    </div>
                                  
                                   
                                </div>
                                
                                <div className="form-group">
                                    
                                    <div className="col-md-12">

                                        
                                        <Markup content={model && model.Body} /> 
                       
                                    </div>
                                   
                                   
                                </div>
                                {this.state.Files.length > 0 &&
                                
                                    <div className="form-group">
                                    
                                        <div className="col-md-4">

                                            <div class="panel panel-default">
                                                <div class="panel-heading">
                                                    <a data-toggle = "collapse" href = "#attachement">
                                                        <i class="fa fa-paperclip" ></i> پیوست ({this.state.Files.length})
                                                    </a>                   
                                                </div>
                                                <div id = "attachement" className = "panel-collapse collapse">
                                                    <div class="panel-body">
                                                        <ul>
                                                        {Files && Files.map((file)=> {
                                                            return (
                                                                <li><a href={apiConstants.API_URL+'/file/'+ file} target="_blank" >{file}</a></li>
                                                            )


                                                        })} 
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        
                                        <div className="col-md-8"></div>
                                    
                                    
                                    </div>
                                }

                            </div>
                        </div>
                       
                        
                        
                       
                    </form>
                
                
                </div>
            </div>
               
            </div>
        </PanelLayout>





        );
    }
}

 
export default ShowMessage;